import { useEffect, useState } from "react";
import { CheckCircle2, XCircle, RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Diagnostics() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const r = await api.get("/admin/diagnostics"); setData(r.data); }
    finally { setBusy(false); }
  };
  useEffect(() => { run(); }, []);

  return (
    <div className="p-8 lg:p-10 max-w-3xl">
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="tech-label">System</p>
          <h1 className="font-display text-4xl font-black tracking-tighter">Diagnostics.</h1>
        </div>
        <Button onClick={run} disabled={busy} className="bg-zinc-900 text-white h-11" data-testid="run-diagnostics-btn"><RefreshCw size={14} className={`mr-2 ${busy && "animate-spin"}`}/>Run Checks</Button>
      </div>

      {!data ? <div className="text-zinc-500">Loading…</div> : (
        <div className="border border-zinc-200 rounded-lg bg-white divide-y divide-zinc-100" data-testid="diagnostics-list">
          {data.checks.map((c) => (
            <div key={c.name} className="p-4 flex items-start gap-3">
              {c.ok ? <CheckCircle2 size={18} className="text-emerald-600 mt-0.5"/> : <XCircle size={18} className="text-red-600 mt-0.5"/>}
              <div className="flex-1">
                <p className="font-semibold text-sm">{c.name}</p>
                <p className="text-xs text-zinc-500 mt-0.5">{c.detail}</p>
              </div>
              <span className={`text-xs font-bold uppercase tracking-wider rounded px-2 py-0.5 ${c.ok ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}`}>{c.ok ? "OK" : "FAIL"}</span>
            </div>
          ))}
          <div className="p-4 flex items-center justify-between bg-zinc-50">
            <p className="tech-label">Overall</p>
            <span className={`text-xs font-bold uppercase tracking-wider rounded px-2 py-0.5 ${data.ok ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}`}>{data.ok ? "Healthy" : "Attention"}</span>
          </div>
        </div>
      )}
    </div>
  );
}
